import { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Form, Table } from "react-bootstrap";

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas';
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'

import LoadingOverlay from '../../components/LoadingOverlay'
import { SelectElement } from "../../components/selectElement2";
import { NoAcceso } from '../../components/NoAcceso';
import { serverApi } from '../../api';


export const ModulosTipoAtencionPage = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);
    const pantallas = useGetPantallas();

    const [isLoading, setIsLoading] = useState(false);
    const [modulo, setModulo] = useState([]);
    // const [ atencion, setAtencion ] = useState([]);
    // const [ moduloSeleccionado, setModuloSeleccionado ] = useState('');

    const [ubicaciones, setUbicaciones] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'tipoAtencion',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: usuario.codigoUbicacion,
        uidModulo: ''
    });

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])

    useHideMenu(false);




    // tabla
    const [data, setData] = useState([]);
    // const [total, setTotal] = useState(0);
    // const totalPages = Math.ceil(total / query.limit);

    // const [searchInput, setSearchInput] = useState('');





    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );

                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

                const resp = await serverApi.post(`/modulos/select-modulos`, { codigoEntidad, codigoUbicacion });
                console.log(resp);

                const opciones = resp.data.listaModulos.map((item) => ({ value: item.uidModulo, label: ` ${item.moduloClase.toUpperCase()} - ${item.modulo.toUpperCase()} ` }))
                setModulo(opciones)

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [query, usuario])

    // const handleSearch = (ev) => {
    //     setQuery(prev => ({
    //         ...prev,
    //         search: ev.target.value,
    //         page: 1
    //     }));
    // };

    // useEffect(() => {
    //     const timeout = setTimeout(() => {

    //         if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

    //         setQuery(prev => {
    //             if (prev.search === searchInput) return prev; // 🔥 evita re-render

    //             return {
    //                 ...prev,
    //                 search: searchInput,
    //                 page: 1
    //             };
    //         });

    //     }, 800); 

    //     return () => clearTimeout(timeout);

    // }, [searchInput]);


    // const paginate = (page) => {
    //     if (page < 1 || page > totalPages) return;

    //     setQuery(prev => ({
    //         ...prev,
    //         page
    //     }));
    // };

    // const handleSort = (field) => {
    //     setQuery(prev => ({
    //         ...prev,
    //         sortBy: field,
    //         sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc'
    //     }));
    // };


    // // **************************table

    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
                console.log(query);


                const resp = await serverApi.post(
                    `/modulos/modulo-tiposAtencion`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );

                console.log(resp);


                setData(resp.data.listaAtenciones || []);
                // setTotal(resp.data.total || 0);

            } catch (error) {
                console.error("Error al obtener tipos de atención", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario])

    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            setData(lista);
            console.log(lista);
        };

        socket.on('lista-modulos-tiposAtencion', handler);

        return () => {
            socket.off('lista-modulos-tiposAtencion', handler);
        };

    }, [socket]);

    const handleChecked = async (seleccion) => {


        const uidTipoAtencion = seleccion.target.id;
        const checked = seleccion.target.checked;
        if (query.uidModulo === "") return;

        try {

            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if (codigoEntidad === "") return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
            console.log(query);

            await serverApi.put(
                `/modulos/modulo-tipoAtencion-edita`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    checked
                }
            );

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }

    }


    const handleSelectUbicacion = (selected) => {
        setQuery(prev => ({
            ...prev,
            ideUbicacion: selected.value,
            codigoUbicacion: selected.data
        }));
    };

    const handleSelectModulo = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidModulo: selected.value,

        }));
    };

    if (usuario.uidUsuario === null) {
        return (<></>)
    }
    else if (!pantallas.includes("tiposatencion")) {
        return (<NoAcceso />)
    } else {
        return (
            <>

                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''} m-1`} style={{ minHeight: '100vh' }}>


                    <div className='row'>

                        <div className='col-12 col-md-4'>

                            <div className='p-3'>
                                <label>Sede/ubicación</label>
                                <SelectElement
                                    options={ubicaciones}
                                    name={`idUbicacion`}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                    onChange={(selected) => handleSelectUbicacion(selected)}
                                    classname="form-control form-control-lg"
                                    isClearable={false}
                                />

                            </div>

                            <div className='p-3'>

                                <Form.Label>Módulo</Form.Label>
                                <SelectElement
                                    options={modulo}
                                    name={"modulo"}
                                    isMulti={false}
                                    closeOnMenuSelect={true}
                                    value={modulo.find(u => u.value === query.uidModulo)}
                                    onChange={(selected) => handleSelectModulo(selected)}
                                    isClearable={false}

                                />
                            </div>


                        </div>

                        <div className='col-12 col-md-8 mt-2'>

                            <div className='form-group col-lg-8 col-12 rounded shadow p-3'>

                                <div className='row'>
                                    <div className='col-12'>
                                        <div className=' float-end col-lg-4 col-12'>

                                            {/* <input
                                                    type='text'
                                                    placeholder='Buscar...'
                                                    className='form-control'
                                                    value={searchInput}
                                                    onChange={(ev) => setSearchInput(ev.target.value)}
                                                /> */}

                                        </div>

                                    </div>

                                    <div className='col-12'>
                                        <Table responsive="sm" striped hover style={{ minWidth: 400 }} className='max400'>
                                            <thead>
                                                <tr>
                                                    <th width={'5%'}></th>
                                                    <th width={'95%'}>Tipo Atención</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item, i) => (

                                                    <tr key={item.uidTipoAtencion}>
                                                        <td width={'5%'}>

                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    checked={item.checked}
                                                                    type="checkbox"
                                                                    id={`${item.uidTipoAtencion}`}
                                                                    onChange={(seleccion) => handleChecked(seleccion)}



                                                                />

                                                                <label className="form-check-label" htmlFor="chkAsignado_"></label>
                                                            </div>


                                                        </td>
                                                        <td width={'95%'}>
                                                            {item.tipoAtencion.toUpperCase()}
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>

                                </div>



                            </div>

                        </div>
                    </div>




                </div>
            </>
        )
    }
}
